import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";

export const ConfigService = {
    /**
     * Pobiera wartość konfiguracji według typu
     * @param {string} type - Typ konfiguracji (np. 'SUPPORT_URL')
     * @returns {Promise<{type: string, value: string}>}
     */
    getConfigByType: (type) => {
        return fetchWithAuth(`/portal/config/${type}`, { method: 'GET' });
    }
};
